module.exports = __webpack_public_path__ + "static/media/mbbank.d08c1623.png";